import * as yup from "yup";

export const FormSchema = yup
  .object({
    sponsoredPlayer: yup.bool(),
    sponsor: yup.string().nullable(),
   /*  verificationCode: yup.string().when("sponsoredPlayer", {
      is: true,
      then: yup.string(),//.required("Este campo es requerido"),
      otherwise: yup.string(),
    }), */
    name: yup.string().required("Este campo es requerido"),
    lastname: yup.string().required("Este campo es requerido"),
    email: yup
      .string()
      .email("Ingrese un email valido")
      .required("Este campo es requerido"),
    documentType: yup.number().required("Este campo es requerido"),
    documentNumber: yup.string().when("documentType", {
      is: '1',
      then: yup
        .string()
        .length(11, "Cédula invalida")
        .required("Este campo es requerido"),
      otherwise: yup.string(),
    }),
  })
  .required();

export type TRegisterBody = yup.InferType<typeof FormSchema>;
